import tooltipClasses from '../Tooltip/styles/index.module.scss';

export const getTooltipContainer = () => {
	let tooltipContainer = document.querySelector(`.${tooltipClasses.tooltipContainer}`);

	if (tooltipContainer === null) {
		tooltipContainer = document.createElement('div');
		tooltipContainer.classList.add(tooltipClasses.tooltipContainer);

		document.body.appendChild(tooltipContainer);
	}

	return tooltipContainer;
};
